import { Component } from 'react';

import IconLocation from '../Icons/IconLocation';
import IconHeart from '../Icons/IconHeart';
import IconLogin from '../Icons/IconLogin';

import {
  headerTopMenu,
  headerBottomMenu,
  headerClubs,
} from '../CommonData/headerMenu';

import './styles/header.scss';
import {linkWithUtm} from "../../helpers/linkWithUtm";
import IconInfo from "../Icons/IconInfo";
import IconPhone from "../Icons/IconPhone";

const MIN_DESKTOP_WIDTH = 1200;

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      desktop: null,
      isMainpage: false,
      lastScrollTop: 0,

      headerHide: false,

      submenuClub: false,
      submenuSupport: false,

      search: false,
      searchValue: '',
    };

    this.searchInput = null;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.toggleClubList.bind(this));

    this.setState({
      isMainpage: true
    });

    this.toggleClubList();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    window.removeEventListener('resize', this.toggleClubList.bind(this));
  }

  handleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.state.lastScrollTop) {
      // downscroll code

      if (scrollTop > 100) {
        this.setState({

          // close submenu
          submenuClub: false,
          submenuSupport: false
        });
      }
    } else {
      // upscroll code
    }

    this.setState({
      lastScrollTop: scrollTop <= 0 ? 0 : scrollTop
    });
  }

  handleHoverOn(type) {
    if (type === 'club') {
      this.setState({
        submenuClub: true
      });
    } else if (type === 'support') {
      this.setState({
        submenuSupport: true
      });
    }
  }

  handleHoverOff(type) {
    if (type === 'club') {
      this.setState({
        submenuClub: false
      });
    } else if (type === 'support') {
      this.setState({
        submenuSupport: false
      });
    }
  }

  toggleClubList() {
    this.setState({
      desktop: window.innerWidth > MIN_DESKTOP_WIDTH
    });
  }

  render() {

    return (
      <div className={`header`}>
        <div className="header__top">
          <div className="container">
            <div className="header__top__place header-place">
              <div className="header-place__location">
                <IconLocation />
                <span>Ростов-на-Дону</span>
              </div>
            </div>
            <nav className="header__top__menu">
              <ul>
                {headerTopMenu.map((el, ind) => {
                  if (el.new_window) {
                    return (
                      <li key={ind}>
                        <a
                          href={linkWithUtm(el.link)}
                          target="_blank"
                          rel="nofollow noopener"
                          className={el.class}
                        >
                          {el.title}
                        </a>
                      </li>
                    );
                  } else if (el.tel || el.email) {
                    return (
                      <li key={ind}>
                        <a href={el.link} className={el.class}>
                          {el.title}
                        </a>
                      </li>
                    );
                  } else {
                    return (
                      <li key={ind}>
                        <a href={linkWithUtm(el.link)} className={el.class}>
                          {el.title}
                        </a>
                      </li>
                    );
                  }
                })}
              </ul>
            </nav>
          </div>
        </div>
        <div className="header__down">
          <div className="container">
            <div itemScope itemType="http://schema.org/Organization" className="header__down__logo">
              <a itemProp="url" href={linkWithUtm('https://fitron.club/')}>
                <img itemProp="logo" src={require('../../static/images/fitron-logo.svg').default} alt="logo"/>
              </a>
              <meta itemProp="name" content="Fitron" />
              <meta itemProp="address" content="Ростов-на-Дону" />
              <meta itemProp="telephone" content="+7 (863) 301-2000" />
            </div>
            <div className="header__down__content">
              <div className="connector">
                <nav className="header-menu">
                  <div className="header-menu__item" key="1">
                    <a
                      href={linkWithUtm("https://fitron.club/clubs/?from=tariff")}
                      className={`${this.state.submenuClub && '_active-item'}`}
                    >
                      Клубы
                    </a>
                    <div
                      className={`header-menu__submenu ${this.state.submenuClub && '_show'}`}
                      onMouseEnter={this.handleHoverOn.bind(this, 'club')}
                      onMouseLeave={this.handleHoverOff.bind(this, 'club')}
                    >
                      <div className="container">
                        <div className="header-menu__submenu__clubs">
                          <div className="header-clubs">
                            {headerClubs.slice(0).reverse().map((el) => (
                              <a
                                href={linkWithUtm(el.link)}
                                key={el.id}
                                className="header-clubs__item"
                              >
                                <img src={el.img} alt="" />
                                <span>{el.title}</span>
                              </a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {headerBottomMenu.map((el) => {
                    if (el.new_window) {
                      return (
                        <div className="header-menu__item" key={el.id}>
                          <a
                            href={linkWithUtm(el.link)}
                            target="_blank"
                            rel="nofollow noopener"
                            className={`${el.class} ${window.location.pathname == el.link ? 'active' : ''}`}
                          >
                            {el.title}
                          </a>
                        </div>
                      );
                    } else {
                      return (
                        <div className="header-menu__item" key={el.id}>
                          <a href={linkWithUtm(el.link)}
                             className={`${el.class} ${window.location.pathname == el.link ? 'active' : ''}`}
                          >
                            {el.title}
                          </a>
                        </div>
                      );
                    }
                  })}
                  <div className="header-menu__item" key="7">
                    <a
                      href={linkWithUtm("https://fitron.club/support/qa/")}
                      className={`${
                        this.state.submenuSupport && '_active-item'
                      }`}
                    >
                      Поддержка
                    </a>
                    <div
                      className={`header-menu__submenu ${this.state.submenuSupport && '_show'}`}
                      onMouseEnter={this.handleHoverOn.bind(this, 'support')}
                      onMouseLeave={this.handleHoverOff.bind(this, 'support')}
                    >
                      <div className="container">
                        <div className="header-menu__submenu__support">
                          <div className="header-support">
                            <div className="header-support__links">
                              <div className="header-support__links__item">
                                <a href={linkWithUtm("https://fitron.club/support/qa/")}></a>
                                <p className="title-links">Вопросы и ответы</p>
                                <p>
                                  Мы&nbsp;собрали самые популярные вопросы
                                  о&nbsp;фитнесе и&nbsp;питании.
                                </p>
                              </div>
                              <div className="header-support__links__item">
                                <a href={linkWithUtm("https://fitron.club/support/blog/")}></a>
                                <p className="title-links">Полезные статьи</p>
                                <p>
                                  Самое актуальное о&nbsp;питании, фитнесе
                                  и&nbsp;здоровье.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
              <div className="header-separate"></div>
              <div className="header-login">
                <div className="header-login__connect">
                  <a href="tel:+78633012000">
                    <IconPhone />
                    <span>301-20-00</span>
                  </a>
                  <div className="header-tooltip">
                    <div className="header-tooltip__trigger">
                      <IconInfo />
                    </div>
                    <div className="header-tooltip__message">
                      <div className="header-tooltip__message-body">
                        <p className="header-tooltip__title">Мы на связи</p>
                        <div className="header-tooltip__content">
                          <p>Пн и Сб - с 9:00 до 21:00</p>
                          <p>Вс и праздничные дни - с 9:00 до 20:00</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="header-separate"></div>
                <div className="header-login__enter">
                  <a href="https://login.fitron.club/" target="_blank" rel="nofollow noopener">
                    <IconLogin />
                    <span>Личный кабинет</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
